module.exports = __webpack_public_path__ + "img/jiqi.ed969915.png";